import React, { useState } from 'react'
import styled from 'styled-components'
import { useBreak } from 'hooks/useBreak'
import { BREAK_ } from 'constants'
import { getFocus, useAtom, useGet, useSet } from 'state/jotai'
import { _drawer, active_project, iconRotate, iso_free, iso_isrotating, seasonMode, turn_building, weaterMode } from 'state/store.global'
import { Icon } from 'assets/Icons_'
import { getIsoData, setIsoData, setSeasonIsoData } from 'state/jotai.isometryDataHooks'
import { SnapOnRotationEnd } from 'components/IsometrySnapOnRotationEnd/SnapOnRotationEnd'
import { _project } from 'state/store.projects'

const WeatherMode = () => {
    const isMobile = useBreak('md_dn')
    const rmode = useGet(iso_free)
    const isrotate = useGet(iso_isrotating)
    const setRmode = useSet(iso_free)
    const setIsrotate = useSet(iso_isrotating)
    const [turnBuilding, setIsTurnBuilding] = useAtom(turn_building);
    const setSeasonMode = useSet(seasonMode);
    const setWeatherMode = useSet(weaterMode);
    const [iconRotated, setIconRotated] = useAtom(iconRotate)
    const config = getIsoData("config");
    const frame = getIsoData("activeframe");
    // const setSeasonFrame = setSeasonIsoData('activeframe')
    
    const setIndex = setIsoData("snapindex");
    const setFrame = setIsoData("activeframe");

    const { pin, pid } = useGet(active_project)
    const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

    const drawer   = useAtom(_drawer)[0]
    const isDetail = drawer.detail

    const click1 = () => {
       // Toggle the weather mode state
        setSeasonMode(!iconRotated)
        // Toggle icon rotation
        setIconRotated(!iconRotated)
        setWeatherMode(!iconRotated)
        setIsTurnBuilding(!iconRotated)
      if(!iconRotated) {
        setIsrotate(true)
        setRmode(true)
      }else {
        setRmode(false)
        setIsrotate(false)
      }
    }
    
    return (
      <>
        { !rmode && ((isMobile && !rmode) || !isMobile) &&
          <Box isDetail={isDetail} onClick={click1}>
            { config && <SnapOnRotationEnd
              {...{ frame, setFrame, config, setIndex, rmode, isrotate }}
            />
            }
              <RotatingIcon icon='sun' size={isMobile ? '25' : '32'} color={'#000'} rotated={iconRotated} />
              <Text>{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Soldiagram')[0]?.Label || "Sun Diagram"}</Text>
          </Box>
        }
      </>
    )
}

export default WeatherMode

const Text = styled.div`
  white-space: nowrap;
  font-size: 18px;
  font-weight: 400;
`
const Box = styled.div`
  gap: 8px;
  cursor: pointer;
  padding: 5px 5px;
  z-index: 5;
  align-items: center;
  display: flex;
     position: absolute;
    top: 86px;
    left: 50%;
    transform: translateX(calc(-50%));
  ${BREAK_.md_up} {
    position: absolute;
    top: 28px;
    left: 50%;
    transform: translateX(calc(-50%));
    padding: 5px 15px;
  }
`

const RotatingIcon = styled(Icon)`
  transition: transform 0.3s ease-in-out;

  ${(props) => props.rotated && `
    transform: rotate(90deg);
  `}
`;
